import {Participant} from './Participant';

export class GroupParticipant {
  workflowId: number;
  participants: Participant[];
}
